import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Mail } from "lucide-react";
import { CONTACT } from "./NSLogo";

export default function StickyContactBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="sticky-contact"
          data-testid="sticky-contact-bar"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-0 left-0 right-0 z-[55] pointer-events-none"
        >
          <div className="max-w-[1600px] mx-auto px-3 md:px-6 lg:px-12 pb-3 md:pb-5">
            <div className="pointer-events-auto grid grid-cols-2 gap-px bg-[#111111] border border-[#111111] shadow-[0_-8px_40px_rgba(0,0,0,0.18)]">
              <a
                href={CONTACT.phoneHref}
                data-testid="sticky-phone"
                className="group flex items-center justify-center gap-2 md:gap-3 bg-[#C17A43] text-[#111111] px-3 md:px-6 py-3.5 md:py-4 hover:bg-[#F5F3EF] transition-colors duration-300"
                aria-label={`Call ${CONTACT.phone}`}
              >
                <Phone size={14} strokeWidth={2} className="flex-shrink-0" />
                <span className="font-mono text-[10px] md:text-[11px] uppercase tracking-[0.16em] md:tracking-[0.22em] whitespace-nowrap">
                  <span className="hidden sm:inline">Dispatch · </span>
                  {CONTACT.phone}
                </span>
              </a>
              <a
                href={CONTACT.emailHref}
                data-testid="sticky-email"
                className="group flex items-center justify-center gap-2 md:gap-3 bg-[#111111] text-[#F5F3EF] px-3 md:px-6 py-3.5 md:py-4 hover:bg-[#C17A43] hover:text-[#111111] transition-colors duration-300 min-w-0"
                aria-label={`Email ${CONTACT.email}`}
              >
                <Mail size={14} strokeWidth={2} className="flex-shrink-0" />
                <span className="font-mono text-[10px] md:text-[11px] normal-case tracking-[0.04em] md:tracking-[0.06em] truncate">
                  <span className="hidden sm:inline uppercase tracking-[0.22em] mr-1.5">
                    Email ·
                  </span>
                  {CONTACT.email}
                </span>
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
